var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCleartrip(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 32
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "cleartrip_svg__a",
    d: "M32.855 27.896c0 2.172-1.412 3.93-3.154 3.93H3.221c-1.74 0-3.151-1.758-3.151-3.93V4.144c0-2.171 1.411-3.93 3.152-3.93h26.48c1.741 0 3.153 1.759 3.153 3.93v23.752z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "cleartrip_svg__c",
    d: "M.048 8.748L3.022 4.16l4.164 6.883L20.568.145l2.973 4.876L6.589 15.345z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cleartrip_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cleartrip_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#E36433",
    mask: "url(#cleartrip_svg__b)",
    d: "M.065 31.851h32.81V.18H.065z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.185 8.762)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "cleartrip_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#cleartrip_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFE",
    mask: "url(#cleartrip_svg__d)",
    d: "M.007 15.383h23.549V.138H.007z"
  })))));
}

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMzMiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMyAzMiI+CiAgPGRlZnM+CiAgICA8cGF0aCBpZD0iY2xlYXJ0cmlwLWEiIGQ9Ik0zMi44NTQ3NzYyLDI3Ljg5NTU0OTQgQzMyLjg1NDc3NjIsMzAuMDY3NzQ4MSAzMS40NDMzMjM3LDMxLjgyNTA1OTYgMjkuNzAxNDYyMiwzMS44MjUwNTk2IEwzLjIyMTg0ODYzLDMxLjgyNTA1OTYgQzEuNDgxNDI5OTUsMzEuODI1MDU5NiAwLjA2OTk3NzQ1NTcsMzAuMDY3NzQ4MSAwLjA2OTk3NzQ1NTcsMjcuODk1NTQ5NCBMMC4wNjk5Nzc0NTU3LDQuMTQzNjkwMDUgQzAuMDY5OTc3NDU1NywxLjk3MjUyNzc0IDEuNDgxNDI5OTUsMC4yMTM4MzQ0NDMgMy4yMjE4NDg2MywwLjIxMzgzNDQ0MyBMMjkuNzAxNDYyMiwwLjIxMzgzNDQ0MyBDMzEuNDQzMzIzNywwLjIxMzgzNDQ0MyAzMi44NTQ3NzYyLDEuOTcyNTI3NzQgMzIuODU0Nzc2Miw0LjE0MzY5MDA1IEwzMi44NTQ3NzYyLDI3Ljg5NTU0OTQgWiIvPgogICAgPHBvbHlnb24gaWQ9ImNsZWFydHJpcC1jIiBwb2ludHM9Ii4wNDggOC43NDggMy4wMjIgNC4xNiA3LjE4NiAxMS4wNDMgMjAuNTY4IC4xNDUgMjMuNTQxIDUuMDIxIDYuNTg5IDE1LjM0NSIvPgogIDwvZGVmcz4KICA8ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPgogICAgPG1hc2sgaWQ9ImNsZWFydHJpcC1iIiBmaWxsPSIjZmZmIj4KICAgICAgPHVzZSB4bGluazpocmVmPSIjY2xlYXJ0cmlwLWEiLz4KICAgIDwvbWFzaz4KICAgIDxwb2x5Z29uIGZpbGw9IiNFMzY0MzMiIHBvaW50cz0iLjA2NSAzMS44NTEgMzIuODc1IDMxLjg1MSAzMi44NzUgLjE4IC4wNjUgLjE4IiBtYXNrPSJ1cmwoI2NsZWFydHJpcC1iKSIvPgogICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoNS4xODUgOC43NjIpIj4KICAgICAgPG1hc2sgaWQ9ImNsZWFydHJpcC1kIiBmaWxsPSIjZmZmIj4KICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiNjbGVhcnRyaXAtYyIvPgogICAgICA8L21hc2s+CiAgICAgIDxwb2x5Z29uIGZpbGw9IiNGRkZGRkUiIHBvaW50cz0iLjAwNyAxNS4zODMgMjMuNTU2IDE1LjM4MyAyMy41NTYgLjEzOCAuMDA3IC4xMzgiIG1hc2s9InVybCgjY2xlYXJ0cmlwLWQpIi8+CiAgICA8L2c+CiAgPC9nPgo8L3N2Zz4K";
export { SvgCleartrip as ReactComponent };